import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { MessageDescriptorPropType } from '../../prop-types/intl';
import { emptyArray } from 'ui-components/default-props/empty';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { FiltersContext } from '../../filters/context';

import style from './bulk-update-menu.module.less';

const MenuItems = ({ actions, ids, filters }) => {
  const intl = useIntl();
  return actions.map(({ name, actionHandler, id, disabled }) => {
    return (
      <DropdownMenuItem
        key={id}
        disabled={disabled}
        onClick={() => actionHandler(ids, filters)}
        title={intl.formatMessage(name)}
        useAdvancedTruncationTitleLogic
      >
        <FormattedMessage {...name} />
      </DropdownMenuItem>
    );
  });
};

const BulkUpdateMenuItems = ({ actionSections = emptyArray, containerClassName = '' }) => {
  const intl = useIntl();
  const { buildApiFilters } = useContext(FiltersContext) || {};
  const filters = buildApiFilters ? buildApiFilters() : null;

  return (
    <div className={containerClassName}>
      {actionSections.map(({ sectionName, actions, ids }) => {
        const label = intl.formatMessage(sectionName);
        return (
          <div key={sectionName.id} className={style['action-section']}>
            {actionSections.length > 1 && (
              <div className={style['action-section-title']} title={label}>
                {label}
              </div>
            )}
            <MenuItems actions={actions} filters={filters} ids={ids} />
          </div>
        );
      })}
    </div>
  );
};

BulkUpdateMenuItems.propTypes = {
  actionSections: PropTypes.arrayOf(
    PropTypes.shape({
      sectionName: MessageDescriptorPropType,
      actions: PropTypes.arrayOf(
        PropTypes.shape({
          name: MessageDescriptorPropType,
          actionHandler: PropTypes.func,
          id: PropTypes.string,
          disabled: PropTypes.bool,
        }),
      ),
    }),
  ),
  containerClassName: PropTypes.string,
};

export default BulkUpdateMenuItems;
